import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(theme => ({
	root: {
		marginLeft: theme.spacing(-2),
		marginRight: theme.spacing(-2),
		[theme.breakpoints.up('sm')]: {
			marginLeft: theme.spacing(-3),
			marginRight: theme.spacing(-3),
		},
	},
	paper: {
		borderRadius: 0,
		padding: theme.spacing(6, 3),
		display: 'flex',
		alignItems: 'center',
		flexDirection: 'column',
		[theme.breakpoints.up('md')]: {
			flexDirection: 'row',
			padding: theme.spacing(7, 16.2, 7, 6),
		},
	},
	imageBox: {
		flexShrink: 0,
		width: theme.spacing(31),
		marginRight: 0,
		marginBottom: theme.spacing(4.8),
		'& img': {
			width: '100%',
		},
		[theme.breakpoints.up('md')]: {
			marginRight: theme.spacing(6),
			marginBottom: 0,
		},
	},
	content: {
		[theme.breakpoints.up('md')]: {
			alignItems: 'start',
		},
	},
	buttonWrap: {
		justifyContent: 'start',
	},
	cardContainer: {},
	container: {},
}))

export default useStyles
